import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { MachineException } from "@/model/data/logAnalysis/MachineException";

export class GetMachineExceptionsResData extends ApiGenericResponse {
    machineExceptions: MachineException[];
    componentLabelMap: Map<string, string>;
    unitLabelMap: Map<number, string>;
    troubleshooting: Map<number, Map<string, string>>;
    imagesLegend: Map<number, string>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.MachineExceptions) {
            this.machineExceptions = new Array();
            obj.MachineExceptions.forEach((element) => {
                let me = new MachineException();
                me.parse(element);
                this.machineExceptions.push(me);
            });
        }
        if (obj.ComponentsLabelMap) {
            this.componentLabelMap = obj.ComponentsLabelMap;
        }
        if (obj.UnitLabelMap) {
            this.unitLabelMap = obj.UnitLabelMap;
        }
        if (obj.Troubleshooting) {
            this.troubleshooting = obj.Troubleshooting;
        }
        if (obj.ImagesLegend) {
            this.imagesLegend = new Map<number, string>();
            Object.entries(obj.ImagesLegend).forEach((pair: any) => {
                this.imagesLegend.set(pair[0], pair[1]);
            });
        }
    }
}
